// Importing external scripts
import "./custom_admin.js";
import "./csv_exporter.js";
import "../library/js/slick.js";
// Import SCSS (processed by Vite)
import "../sass/style.scss";

// jQuery in WordPress runs in noConflict mode ($ is undefined globally).
var $ = jQuery;

// Custom Scripts
$(function () {
  // Functions that need to run on page load
  show_vei_logo();
  slickSlider();

  // Functions that attach event handlers using jQuery's .on() method
  play_video();

  // Functions that need to set up elements on page load
  handleVideoIframes();
  check4BookingForm();

  // Accordion exclusive toggle handler
  document.addEventListener(
    "toggle",
    function (event) {
      if (event.target.tagName === "DETAILS") {
        var details = event.target;
        var container = details.parentElement;

        if (
          container &&
          container.classList.contains("accordion-exclusive") &&
          details.open
        ) {
          // Close all other details in the same container
          var allDetails = container.querySelectorAll("details");
          allDetails.forEach(function (otherDetails) {
            if (otherDetails !== details) {
              otherDetails.open = false;
            }
          });
        }
      }
    },
    true,
  ); // Use capture phase

  // Click handlers (Not required at document ready)
  book_free_assessment();
  form_1();
  form_2();
  form_3();
  have_feedback();
  have_a_question();
  order_info_pack();
});
// END DOCUMENT READY

// DOCUMENT RESIZE
window.addEventListener("resize", function () {});
// END DOCUMENT RESIZE

// FUNCTIONS
function equalHeights(the_li) {
  var $the_li = $(the_li);
  var $maxHeight = 0;
  $the_li.each(function () {
    var $thisHeight = $(this).outerHeight();
    if ($thisHeight > $maxHeight) {
      $maxHeight = $thisHeight;
    }
  });
  $the_li.height($maxHeight);
}

function play_video() {
  $("body").on("click", ".video-thumbnail-link", function (e) {
    e.preventDefault();
    $(this).addClass("play-video");
    var $iframe = $(this).next(".video-thumbnail").find("iframe");
    var src = $iframe.attr("src");

    // Check if it's a Facebook video
    if (src.includes("facebook.com")) {
      // Facebook needs different parameters
      if (!src.includes("&autoplay=true")) {
        $iframe.attr("src", src + "&autoplay=true");
      }
    } else {
      // YouTube/Vimeo videos
      if (!src.includes("?autoplay=1")) {
        $iframe.attr("src", src + "?autoplay=1");
      }
    }
  });

  // Close video modal when clicking close icon
  $("body").on("click", ".video-thumbnail__close-icon", function (e) {
    close_video_modal();
  });

  // Close video modal when pressing Escape key
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      // Check if any video modal is currently open
      if ($(".video-thumbnail-link.play-video").length > 0) {
        e.preventDefault(); // Prevent default Escape key behavior
        close_video_modal();
      }
    }
  });
}

function close_video_modal() {
  // Find any open video modals
  var $activeVideos = $(".video-thumbnail-link.play-video");

  // Close all active video modals
  $activeVideos.each(function () {
    var $link = $(this);
    var $iframe = $link.next(".video-thumbnail").find("iframe");
    if ($iframe.length > 0) {
      var src = $iframe.attr("src");
      if (src.includes("facebook.com")) {
        $iframe.attr("src", src.replace("&autoplay=true", ""));
      } else {
        $iframe.attr("src", src.replace("?autoplay=1", ""));
      }
    }
    $link.removeClass("play-video");
  });
}

// fix for lazy iframe (WP Rocket option) breaking videos on eyeMatters video tiles
function handleVideoIframes() {
  var vidReel = document.querySelectorAll(".video, .eyehub_video");
  vidReel.forEach(function (element, index) {
    var thisFrame = element.querySelector("iframe");
    // Check if iframe exists before proceeding
    if (thisFrame) {
      var thisFrameSrc = thisFrame.getAttribute("src");
      var thisFrameLazySrc = thisFrame.getAttribute("data-lazy-src");

      // Only proceed if we have a lazy-src attribute
      if (thisFrameLazySrc) {
        var thisVidLink = element.querySelector(".video-thumbnail-link");
        if (thisVidLink) {
          thisVidLink.addEventListener("click", function () {
            thisFrame.setAttribute("src", "about:blank");
            thisFrame.setAttribute("src", thisFrameLazySrc);
          });
        }

        var closeVidButton = element.querySelector(
          ".video-thumbnail__close-icon",
        );
        if (closeVidButton) {
          closeVidButton.addEventListener("click", function () {
            thisFrame.setAttribute("src", "about:blank");
            thisFrame.setAttribute("src", thisFrameLazySrc);
          });
        }
      }
    }
  });
}

function show_vei_logo() {
  var the_url_path_name = window.location.pathname;
  if (
    the_url_path_name.indexOf("healthcare-professionals") >= 0 ||
    the_url_path_name.indexOf("events") >= 0 ||
    the_url_path_name.indexOf("hcp") >= 0
  ) {
    $("#logo img.logo_hcp").show();
  } else {
    $("#logo img.logo_public").show();
  }
}

function order_info_pack() {
  $("#order_info_trigger").click(function () {
    $("#have_a_question_form_wrapper").removeClass("open");
    $("#form_wrapper_1").removeClass("open");
    $("#form_wrapper_2").removeClass("open");
    $("#form_wrapper_3").removeClass("open");
    $("#book_free_assessment_form_wrapper").removeClass("open");
    $("#have_a_question_bars").toggleClass("open");
    $("#order_info_pack_form_wrapper").toggleClass("open");

    setTimeout(function () {
      if ($("#order_info_pack_form_wrapper").hasClass("open")) {
        $("html, body").animate(
          { scrollTop: $("#order_info_pack_form_wrapper").offset().top - 200 },
          500,
        );
      }
    }, 50);
  });
}

// NOTE: Form 1-3 are new more generic variations of the Gravity Forms trigger show/hide. Use these for any custom triggers (in combination with CTAs setup in the WordPress back-end) outside of: consultation (which is used in the site header), ask and feedback (which is used on the Footer Have a Question and Feedback forms respectively on every page)

// Form 1
function form_1() {
  $("#form_trigger_1").click(function () {
    $("#have_a_question_form_wrapper").removeClass("open");
    $("#form_wrapper_2").removeClass("open");
    $("#form_wrapper_3").removeClass("open");
    $("#have_a_question_bars").toggleClass("open");
    $("#form_wrapper_1").toggleClass("open");

    setTimeout(function () {
      if ($("#form_wrapper_1").hasClass("open")) {
        $("html, body").animate(
          { scrollTop: $("#form_wrapper_1").offset().top - 200 },
          500,
        );
      }
    }, 50);
  });
}

// Form 2
function form_2() {
  $("#form_trigger_2").click(function () {
    $("#have_a_question_form_wrapper").removeClass("open");
    $("#form_wrapper_1").removeClass("open");
    $("#form_wrapper_3").removeClass("open");
    $("#have_a_question_bars").toggleClass("open");
    $("#form_wrapper_2").toggleClass("open");

    setTimeout(function () {
      if ($("#form_wrapper_2").hasClass("open")) {
        $("html, body").animate(
          { scrollTop: $("#form_wrapper_2").offset().top - 200 },
          500,
        );
      }
    }, 50);
  });
}

// Form 3
function form_3() {
  $("#form_trigger_3").click(function () {
    $("#have_a_question_form_wrapper").removeClass("open");
    $("#form_wrapper_1").removeClass("open");
    $("#form_wrapper_2").removeClass("open");
    $("#have_a_question_bars").toggleClass("open");
    $("#form_wrapper_3").toggleClass("open");

    setTimeout(function () {
      if ($("#form_wrapper_3").hasClass("open")) {
        $("html, body").animate(
          { scrollTop: $("#form_wrapper_3").offset().top - 200 },
          500,
        );
      }
    }, 50);
  });
}

function have_feedback() {
  $("#have_feedback_trigger").click(function () {
    $("#have_a_question_form_wrapper").removeClass("open");
    $("#order_info_pack_form_wrapper").removeClass("open");
    $("#form_wrapper_1").removeClass("open");
    $("#form_wrapper_2").removeClass("open");
    $("#form_wrapper_3").removeClass("open");
    $("#book_free_assessment_form_wrapper").removeClass("open");
    $("#have_feedback_form_wrapper").toggleClass("open");
    $("#have_feedback_hcp_form_wrapper").toggleClass("open");

    setTimeout(function () {
      if ($("#have_feedback_form_wrapper").hasClass("open")) {
        $("html, body").animate(
          { scrollTop: $("#have_feedback_wrapper").offset().top - 200 },
          500,
        );
      }
    }, 50);
  });
}

function have_a_question() {
  $("#have_a_question_trigger").click(function () {
    $("#have_feedback_form_wrapper").removeClass("open");
    $("#order_info_pack_form_wrapper").removeClass("open");
    $("#form_wrapper_1").removeClass("open");
    $("#form_wrapper_2").removeClass("open");
    $("#form_wrapper_3").removeClass("open");
    $("#book_free_assessment_form_wrapper").removeClass("open");
    $("#have_a_question_bars").toggleClass("open");
    $("#have_a_question_form_wrapper").toggleClass("open");
    $("#have_a_question_hcp_form_wrapper").toggleClass("open");

    setTimeout(function () {
      if ($("#have_a_question_form_wrapper").hasClass("open")) {
        $("html, body").animate(
          { scrollTop: $("#have_a_question_wrapper").offset().top - 350 },
          500,
        );
      }
    }, 50);
  });

  $(".have_question").click(function (e) {
    e.preventDefault();
    $("#have_a_question_trigger").trigger("click");
  });
}

function book_free_assessment() {
  $("#book_free_assessment_trigger").click(function () {
    $("#order_info_pack_form_wrapper").removeClass("open");
    $("#have_a_question_form_wrapper").removeClass("open");
    $("#form_wrapper_1").removeClass("open");
    $("#form_wrapper_2").removeClass("open");
    $("#form_wrapper_3").removeClass("open");
    $("#book_free_assessment_form_wrapper").toggleClass("open");

    setTimeout(function () {
      if ($("#book_free_assessment_form_wrapper").hasClass("open")) {
        $("html, body").animate(
          {
            scrollTop:
              $("#book_free_assessment_form_wrapper").offset().top - 200,
          },
          500,
        );
      }
    }, 50);
  });
}

// HEADER Booking CTA: Check if booking form exists on page
function check4BookingForm() {
  $(".sticky-booking-cta").on("click", function (e) {
    var formWrapper = document.getElementById("form_wrapper_1");

    if (formWrapper) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $(".scroll_to_filters").offset().top - 200,
        },
        500,
      );
      $(formWrapper).toggleClass("open");
    }
  });
}

function mobileMenu() {
  const mobileExpand = document.getElementById("mobile_expand");
  const mobileMenu = document.getElementById("mobile_menu");
  const mobileClose = document.getElementById("mobile_close");
  const mobileVeil = document.getElementById("mobile_veil");
  const mobilePrimaryNav = document.getElementById("mobile_primary_nav");

  mobileExpand.addEventListener("click", function () {
    mobileMenu.classList.add("is-active");
    this.style.display = "none";
    mobileClose.style.display = "block";
    mobileVeil.style.display = "block";
    window.scrollTo({ top: 0, behavior: "smooth" });
    mobileMenu.style.display = "block";
  });

  mobileClose.addEventListener("click", function () {
    mobileMenu.classList.remove("is-active");
    this.style.display = "none";
    mobileMenu.style.display = "none";
    mobileVeil.style.display = "none";
    mobileExpand.style.display = "block";
    setTimeout(function () {
      let subMenus = mobilePrimaryNav.querySelectorAll(
        "li.menu-item-has-children .sub-menu",
      );
      subMenus.forEach((subMenu) => (subMenu.style.display = "none"));
    }, 1000);
  });

  let menuItems = mobilePrimaryNav.querySelectorAll(
    "li.menu-item-has-children",
  );
  menuItems.forEach(function (menuItem) {
    let button = document.createElement("button");
    button.className = "toggle_the_child";
    button.title = "touch to toggle sub menu";
    button.innerHTML = "&#xf0d7;";
    let anchor = menuItem.querySelector("a");

    button.addEventListener("click", function () {
      let subMenu = menuItem.querySelector(".sub-menu");
      let isSubMenuOpen = subMenu.style.display === "block";
      subMenu.style.display = isSubMenuOpen ? "none" : "block";
      button.innerHTML = isSubMenuOpen ? "&#xf0d7;" : "&#xf0d8;";
      anchor.classList.toggle("active-submenu");
    });
    menuItem.appendChild(button);
  });

  document
    .querySelectorAll(
      "#mobile_primary_nav > #primary_nav > li.menu-item-has-children > a",
    )
    .forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        let subMenu = this.parentNode.querySelector(".sub-menu");
        let button = this.parentNode.querySelector(".toggle_the_child");
        let isSubMenuOpen = subMenu.style.display === "block";
        subMenu.style.display = isSubMenuOpen ? "none" : "block";
        button.innerHTML = isSubMenuOpen ? "&#xf0d7;" : "&#xf0d8;";
        this.classList.toggle("active-submenu");
      });
    });
}

// Wrap mobileMenu call in DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  mobileMenu();
});

// SLICK SLIDER - HOME PAGE
function slickSlider() {
  // Destroy existing instance if it exists
  if ($(".js-banner-carousel").hasClass("slick-initialized")) {
    $(".js-banner-carousel").slick("unslick");
  }

  // Initialize the banner carousel
  $(".js-banner-carousel").slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 8000,
    speed: 1200,
    cssEase: "ease",
    adaptiveHeight: true,
    pauseOnHover: true,
    draggable: true,
  });
  $(".js-home-services-carousel").slick({
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplaySpeed: 10000,
    speed: 1200,
    cssEase: "ease",
    adaptiveHeight: true,
    pauseOnHover: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          speed: 1000,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          speed: 800,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".js-clinic-testimonials").slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 8000,
    speed: 1200,
    cssEase: "ease",
    adaptiveHeight: true,
    pauseOnHover: true,
    draggable: true,
  });
}

// Toggle read more/less buttons
// NOTE: requires -read_more element to be wrapped in a parent element (usually .cta-buttons)
document.addEventListener("DOMContentLoaded", () => {
  const readMoreButtons = document.querySelectorAll(".-read_more");

  // Hides/shows content, changes button text and arrow display
  const toggleContent = (readMoreButton, content, toggleState) => {
    readMoreButton.innerHTML = `${
      toggleState ? "Read less" : "Read more"
    } <span class="arrow-down"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" color="#fff">
  <path d="M4.14 0.5L7.98 4.28H0V5.42H7.98L4.44 8.84L4.14 9.14H5.64L10.02 4.82L5.64 0.5H4.14Z" fill="currentColor"/>
</svg></span>`;
    content.style.display = `${toggleState ? "block" : "none"}`;
  };

  // Only run if "read more" buttons are on the page
  if (readMoreButtons.length > 0) {
    readMoreButtons.forEach((readMoreButton) => {
      readMoreButton.addEventListener("click", () => {
        const content = readMoreButton.parentElement.nextElementSibling;

        if (!readMoreButton.classList.contains("open")) {
          readMoreButton.classList.add("open");
          toggleContent(readMoreButton, content, true);
        } else {
          readMoreButton.classList.remove("open");
          toggleContent(readMoreButton, content, false);
        }
      });
    });
  }
});

// Toggle Transcript button
document.addEventListener("DOMContentLoaded", () => {
  const transcriptButtons = document.querySelectorAll(".-transcript");

  // Hides/shows content, changes button text and arrow display
  const toggleContent = (transcriptButton, content, toggleState) => {
    transcriptButton.innerHTML = `${
      toggleState ? "Hide transcript" : "Show transcript"
    } <span class="arrow-down"><svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"> <g color="#fff"> <path fill="currentColor" d="m16.1 8h-1.8l6.4 6.4h-13.7v1.3h13.7l-6.3 6.2-.1.1h1.8l7-7z"></path></g></svg></span>`;
    content.style.display = `${toggleState ? "block" : "none"}`;
  };

  // Only run if "read more" buttons are on the page
  if (transcriptButtons.length > 0) {
    transcriptButtons.forEach((transcriptButton) => {
      transcriptButton.addEventListener("click", () => {
        const content = transcriptButton.nextElementSibling;

        if (!transcriptButton.classList.contains("open")) {
          transcriptButton.classList.add("open");
          toggleContent(transcriptButton, content, true);
        } else {
          transcriptButton.classList.remove("open");
          toggleContent(transcriptButton, content, false);
        }
      });
    });
  }
});

// more-info Buttons
$(function () {
  const quickViewButtons = document.querySelectorAll("[data-quick-view]");
  const closeButtons = document.querySelectorAll("[data-close]");
  const fullwidthCards = document.querySelectorAll(".-more_info");
  let toggle; // Quick view <button>.
  let toggleParent; // <li>.
  let fullwidth; // Fullwidth card to be "injected".

  const openQuickView = (toggle, toggleParent, fullwidth) => {
    toggle.setAttribute("aria-expanded", "true");
    toggleParent.classList.toggle("is-selected");
    fullwidth.classList.toggle("is-hidden");
    // Make fullwidth card keyboard focusable.
    fullwidth.setAttribute("tabIndex", "0");
  };

  const closeQuickView = (toggle, toggleParent, fullwidth) => {
    toggle.setAttribute("aria-expanded", "false");
    toggleParent.classList.toggle("is-selected");
    fullwidth.classList.toggle("is-hidden");
    fullwidth.removeAttribute("tabIndex");
  };

  quickViewButtons.forEach((quickView) => {
    // Add appropriate ARIA attributes for "toggle" behaviour.
    fullwidth = quickView.parentElement.nextElementSibling;
    quickView.setAttribute("aria-expanded", "false");
    quickView.setAttribute("aria-controls", fullwidth.id);

    quickView.addEventListener("click", (e) => {
      toggle = e.target;
      toggleParent = toggle.parentElement;
      fullwidth = toggleParent.nextElementSibling;

      // Open (or close) fullwidth card.
      if (toggle.getAttribute("aria-expanded") === "false") {
        // Do we have another fullwidth card already open? If so, close it.
        fullwidthCards.forEach((fullwidthOpen) => {
          if (!fullwidthOpen.classList.contains("is-hidden")) {
            toggleParentOpen = fullwidthOpen.previousElementSibling;
            toggleOpen = toggleParentOpen.querySelector("[data-quick-view]");

            closeQuickView(toggleOpen, toggleParentOpen, fullwidthOpen);
          }
        });

        openQuickView(toggle, toggleParent, fullwidth);
      } else {
        closeQuickView(toggle, toggleParent, fullwidth);
      }
    });
  });

  closeButtons.forEach((close) => {
    close.addEventListener("click", (e) => {
      fullwidth = e.target.parentElement;
      toggleParent = e.target.parentElement.previousElementSibling;
      toggle = toggleParent.querySelector("[data-quick-view]");

      closeQuickView(toggle, toggleParent, fullwidth);
      toggle.focus(); // Return keyboard focus to "toggle" button.
    });
  });
});

/**
 * MODAL windows
 * Initializes modal functionality for elements with data-p-open-modal attributes
 */
$(function () {
  // Cache DOM elements
  const modalBackground = document.querySelector(".modal-background");
  const modalTriggers = document.querySelectorAll("[data-open-modal]");
  const closeButtons = document.querySelectorAll("[data-modal-close]");
  const modalElements = document.querySelectorAll(".modal");

  // Early return if required elements are missing
  if (!modalBackground) {
    console.warn("Modal background element not found");
    return;
  }

  // Store event handlers for cleanup
  const handlers = {
    openModal: new Map(),
    cancelModal: new Map(),
    clickModal: new Map(),
    backgroundClick: null,
  };

  // Handle modal opening
  const handleModalOpen = (event) => {
    event.preventDefault();
    const selector = event.currentTarget.getAttribute("data-open-modal");

    if (!selector) {
      console.warn("Error: data-open-modal attribute is empty");
      return;
    }

    const targetModal = document.querySelector(selector);
    if (!targetModal) {
      console.warn(`Error: No modal found with selector "${selector}"`);
      return;
    }

    // Reset iframe source to force reload if it's the jobs modal
    if (selector === "#jobs-modal") {
      const iframe = document.getElementById("elmo-modal-iframe");
      if (iframe) {
        iframe.src = iframe.src;

        // Initialize iframe resizer when modal is shown
        const observer = new MutationObserver(function (mutations) {
          if (targetModal.classList.contains("active")) {
            // Initialize iframe resizer
            if (typeof iFrameResize === "function") {
              iFrameResize(
                {
                  log: true,
                  checkOrigin: false,
                  heightCalculationMethod: "max",
                  minHeight: 600,
                  maxHeight: function () {
                    return window.innerHeight - 100;
                  },
                },
                "#elmo-modal-iframe",
              );
            }
            observer.disconnect();
          }
        });

        observer.observe(targetModal, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    }

    modalBackground.classList.add("nowactive");
    document.body.classList.add("modal-opened");
    targetModal.classList.add("active");
  };

  // Handle modal closing
  const handleModalClose = (event) => {
    event.preventDefault();
    const activeModal = document.querySelector(".modal.active");
    if (activeModal) {
      // Clean up iframe resizer if it's the jobs modal
      if (
        activeModal.id === "jobs-modal" &&
        typeof iFrameResize !== "undefined"
      ) {
        const iframe = document.getElementById("elmo-modal-iframe");
        if (iframe && iframe.iFrameResizer) {
          iframe.iFrameResizer.close();
        }
      }

      activeModal.classList.remove("active");
      modalBackground.classList.remove("nowactive");
      document.body.classList.remove("modal-opened");
    }
  };

  // Handle modal content click (prevent propagation)
  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  // Handle background click
  const handleBackgroundClick = (event) => {
    event.preventDefault();
    const openedModal = document.querySelector(".modal.active");

    if (openedModal?.getAttribute("data-p-close-on-outside") === "true") {
      event.stopPropagation();
      openedModal.classList.remove("active");
      modalBackground.classList.remove("nowactive");
      document.body.classList.remove("modal-opened");
    }
  };

  // Add event listeners
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", handleModalOpen);
    handlers.openModal.set(trigger, handleModalOpen);
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", handleModalClose);
    handlers.cancelModal.set(button, handleModalClose);
  });

  modalElements.forEach((modal) => {
    modal.addEventListener("click", handleModalClick);
    handlers.clickModal.set(modal, handleModalClick);
  });

  modalBackground.addEventListener("click", handleBackgroundClick);
  handlers.backgroundClick = handleBackgroundClick;

  // Return cleanup function
  return () => {
    // Remove modal trigger listeners
    modalTriggers.forEach((trigger) => {
      const handler = handlers.openModal.get(trigger);
      trigger.removeEventListener("click", handler);
    });

    // Remove close button listeners
    closeButtons.forEach((button) => {
      const handler = handlers.cancelModal.get(button);
      button.removeEventListener("click", handler);
    });

    // Remove modal click listeners
    modalElements.forEach((modal) => {
      const handler = handlers.clickModal.get(modal);
      modal.removeEventListener("click", handler);
    });

    // Remove background click listener
    if (modalBackground && handlers.backgroundClick) {
      modalBackground.removeEventListener("click", handlers.backgroundClick);
    }

    // Clear handler maps
    handlers.openModal.clear();
    handlers.cancelModal.clear();
    handlers.clickModal.clear();
    handlers.backgroundClick = null;
  };
});
